// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-msg {
  font-size: 12px;
}
.dashboard-msg .dashboard-msg--header {
  padding-bottom: 10px;
}
@media (max-width: 568px) {
  .dashboard-msg .dashboard-msg--header {
    flex-direction: column-reverse;
  }
}
.dashboard-msg .dashboard-msg--header .col__date {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.dashboard-msg .dashboard-msg--title {
  color: #314588;
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  display: flex;
  align-items: center;
  line-height: 1.1;
}
@media (min-width: 768px) {
  .dashboard-msg .dashboard-msg--title {
    margin-left: 16px;
  }
}
.dashboard-msg .dashboard-msg--date {
  line-height: 1;
  font-size: 12px;
  font-weight: normal;
  color: #605260;
  text-align: right;
}
@media (min-width: 768px) {
  .dashboard-msg .dashboard-msg--date {
    font-size: 13px;
  }
}
.dashboard-msg .dashboard-msg--info {
  font-size: 13px;
  color: #605260;
}
@media (min-width: 768px) {
  .dashboard-msg .dashboard-msg--info {
    margin-left: 48px;
  }
}
@media (min-width: 768px) {
  .dashboard-msg .dashboard-msg--content {
    margin-left: 48px;
  }
}

.message-title {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.dashboard-icon {
  width: 32px;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/messages/dashboard-message/dashboard-message.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAAE;EACE,oBAAA;AAEJ;AAAI;EAHF;IAII,8BAAA;EAGJ;AACF;AADI;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;AAGN;AACE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EATF;IAUI,iBAAA;EAEJ;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AACJ;AACI;EAPF;IAQI,eAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,cAAA;AACJ;AACI;EAJF;IAKI,iBAAA;EAEJ;AACF;AAEI;EADF;IAEI,iBAAA;EACJ;AACF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AALF;;AAQA;EACI,WAAA;EACA,YAAA;AALJ","sourcesContent":[".dashboard-msg {\n  font-size: 12px;\n  .dashboard-msg--header {\n    padding-bottom: 10px;\n\n    @media (max-width: 568px) {\n      flex-direction: column-reverse;\n    }\n\n    .col__date {\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n    }\n  }\n\n  .dashboard-msg--title {\n    color: #314588;\n    font-size: 14px;\n    font-weight: bold;\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    line-height: 1.1;\n\n    @media (min-width: 768px) {\n      margin-left: 16px;\n    }\n  }\n\n  .dashboard-msg--date {\n    line-height: 1;\n    font-size: 12px;\n    font-weight: normal;\n    color: #605260;\n    text-align: right;\n\n    @media (min-width: 768px) {\n      font-size: 13px;\n    }\n  }\n  // INFO\n  .dashboard-msg--info {\n    font-size: 13px;\n    color: #605260;\n\n    @media (min-width: 768px) {\n      margin-left: 48px;\n    }\n  }\n  // MSG BODY\n  .dashboard-msg--content {\n    @media (min-width: 768px) {\n      margin-left: 48px;\n    }\n  }\n}\n\n\n\n\n\n\n.message-title {\n  color: #3E0D42;\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n}\n\n.dashboard-icon {\n    width: 32px;\n    height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
